import 'resize-observer-polyfill/dist/ResizeObserver.global'
import { useState, useRef, useCallback, useLayoutEffect } from 'react'

function useComponentSize(defaultWidth = 0) {
	const [size, setSize] = useState({
		height: 0,
		width: defaultWidth
	})
	const ref = useRef(null)

	const onResize = useCallback(() => {
		if (!ref.current) {
			return
		}

		const newHeight = (ref.current as any).offsetHeight
		const newWidth = (ref.current as any).offsetWidth

		if (newHeight !== size.height || newWidth !== size.width) {
			setSize({
				height: newHeight,
				width: newWidth
			})
		}
	}, [size.height, size.width])

	useLayoutEffect(() => {
		if (!ref || !ref.current) {
			return
		}

		const resizeObserver = new ResizeObserver(onResize)
		resizeObserver.observe(ref.current)

		return () => resizeObserver.disconnect()
	}, [ref, onResize])

	return {
		ref,
		...size
	}
}

export default useComponentSize
